// @flow

import React from 'react';
import { useTranslation } from 'react-i18next';

import { Content as MobileAppBanner } from '../shared/native-app-banner';
import AppView from '../layouts/AppView';
import Text from '../shared/Typography';

const MobileApps = () => {
  const { t } = useTranslation('mobileApps');

  return (
    <AppView frameless>
      <div className='native-app-banner--signup' style={styles.container}>
        <Text h1>
          {t('get_started')}
        </Text>
        <MobileAppBanner />
      </div>
    </AppView>
  );
};

export default MobileApps;

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 100
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/mobile-apps.js